<template>
  <div class="coupon-input-container">
    <form @submit.prevent="validatedCoupon">
      <b-form-group :label="$t('coupons.coupon-code')">
        <b-input-group>
          <b-form-input
            v-model.trim="code"
            :disabled="loading"
            :state="error ? false : (valid ? true : null)"
            size="lg"
            :placeholder="$t('coupons.coupon-code')"
          />

          <b-input-group-append>
            <b-button
              :variant="valid ? 'success' : 'dark'"
              :disabled="loading || !code"
              @click="validatedCoupon"
            >
              <b-spinner
                v-if="loading"
                small
              />
              <span v-else-if="valid">
                {{ $t('coupons.applied') }}
              </span>
              <span v-else>{{ $t('coupons.apply') }}</span>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </form>
    <small class="text-danger">{{ error }}</small>
  </div>
</template>

<script>
import {
  BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BSpinner, BButton,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import CouponAPIs from '@/API/promotions/coupon-api'
import ErrorHandler from '@/utils/error-handler'
import StorageService from '@/services/storage-service'

export default {
  name: 'CouponInput',
  components: {
    BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BSpinner, BButton,
  },
  props: {
    value: {
      type: [Object, String],
      default: () => ({}),
    },
    targetPackage: {
      type: String,
      default: '',
    },
    currentPackage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      code: this?.$route?.query?.coupon_code || StorageService.getItem('okmenu_coupon') || '',
      error: null,
      valid: null,
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      branchId: 'branches/currentBranchId',
    }),
  },
  watch: {
    value(value) {
      const code = value?.code || value
      if (typeof code === 'string' && code !== this.code) {
        this.code = code
      }
    },
    code(code) {
      if (!code) {
        this.error = null
      }
      if (this.valid) {
        this.valid = false
        this.$emit('input', {})
      }
    },
  },
  mounted() {
    if (this.code) {
      this.validatedCoupon()
    }
  },
  methods: {
    validatedCoupon() {
      this.error = null
      this.loading = true
      this.valid = null
      CouponAPIs.verify(this.code, this.currentPackage, this.targetPackage, this.branchId)
        .then(response => {
          if (!response.verified) {
            this.error = response.message
            return
          }
          this.valid = response.verified
          const coupon = { ...response.coupon, code: this.code }
          this.$emit('input', coupon)
        })
        .catch(e => {
          this.error = ErrorHandler.getErrorDetails(e).title
        })
        .finally(() => { this.loading = false })
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/utils/responsive.scss";

.coupon-input-container {
  background-color: var(--light-gray);
  padding: 37px 15px 23px 15px;

  @include respond-to('large') {
    padding: 37px 42px 23px 36px;
    margin: 0 -42px;
  }
}
</style>
